import type { FC, ReactNode } from 'react';

import className from 'classnames';

import type { FilesKeyframeSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/files';

import { ui } from '../../../utils/helpers';

import styles from './search_items_thumbnail.module.css';

type Props = {
  keyframes?: Partial<FilesKeyframeSchemaWithIdNullable>[];
  fallback: ReactNode;
  warningSign?: ReactNode;
  allowGrowing?: boolean;
};

const settledStatuses = ['CLOSED', 'ACTIVE'];

export const ThumbnailDisplay: FC<Props> = ({
  keyframes,
  fallback,
  warningSign,
  allowGrowing = false,
}) => {
  let photo: string | undefined;

  if (keyframes) {
    const keyframe = keyframes.find(
      (frame) =>
        frame.type === 'KEYFRAME' &&
        frame.url &&
        frame.status &&
        (settledStatuses.includes(frame.status) ||
          (allowGrowing && frame.status === 'GROWING')),
    );

    if (keyframe) {
      photo = keyframe.url ?? undefined;
    }
  }

  return (
    <div className={className(styles.root)} {...ui('search-item-thumbnail')}>
      {photo ? (
        <div
          className={styles.thumbnail}
          style={{
            backgroundImage: `url('${photo}')`,
          }}
        />
      ) : (
        fallback
      )}
      {warningSign}
    </div>
  );
};
